module.exports = __webpack_public_path__ + "img/huayi.f3360f34.jpg";